<template>
    <router-link :to="routerLink">
        <div class="card">
          <div class="card-image">
            <figure class="image is-4by3">
              <img :src="project.image[0].sizes.card" alt="Project logo">
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="title is-4">{{project.name}}</p>
              </div>
            </div>

            <div class="content">
              {{project.pitch}}
            </div>
            <!-- <b-taglist>
                <b-tag>Tag1</b-tag>
                <b-tag>Tag2</b-tag>
                <b-tag>Tag3</b-tag>
            </b-taglist> -->
          </div>
        </div>
    </router-link>
</template>

<style scoped>
.card {
    margin: 8px;
    width: 270px;
}
</style>

<script>
export default {
  name: 'ProjectCard',
  data () {
    return {}
  },
  computed: {
    routerLink() {
      return '/project/' + this.$props.project.id + '/' + this.$root.dashify(this.project.name);
    }
  },
  props: ['project']
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectCard.vue